export default __webpack_public_path__ + "static/media/marek-vogl.65c1419f.jpg";